export const getActionColor = (action: string): any => {
  if (action.startsWith('create')) {
    return 'success';
  } else if (action.startsWith('import')) {
    return 'warning';
  } else if (action.startsWith('update')) {
    return 'info';
  } else if (action.startsWith('delete')) {
    return 'error';
  }
  switch (action.toLowerCase()) {
    case 'create':
      return 'success';
    case 'update':
      return 'info';
    case 'delete':
      return 'error';
    default:
      return 'default';
  }
};

export const getMethodColor = (method: string): any => {
  switch (method.toUpperCase()) {
    case 'POST':
      return 'success';
    case 'PUT':
    case 'PATCH':
      return 'info';
    case 'DELETE':
      return 'error';
    case 'GET':
      return 'default';
    default:
      return 'default';
  }
};
